// store/firmSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Async thunk to fetch firm details
export const fetchFirmDetails = createAsyncThunk(
  "firm/fetchFirmDetails",
  async (firmId, thunkAPI) => {
    try {
      const response = await fetch(
        `/api/attorney/webapp/fetchFirmDetails?firm_id=${firmId}`,
        {
          headers: {
            "Content-Type": "application/json",
            // 'x-api-key': process.env.NEXT_PUBLIC_MY_API_KEY, // If using API key auth
          },
        }
      );
      const data = await response.json();
      if (!response.ok) {
        return thunkAPI.rejectWithValue(data.error);
      }
      return data.firm;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  details: null,
  status: "idle",
  error: null,
};

const firmSlice = createSlice({
  name: "firm",
  initialState,
  reducers: { resetFirm: () => initialState },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFirmDetails.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchFirmDetails.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.details = action.payload;
      })
      .addCase(fetchFirmDetails.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { resetFirm } = firmSlice.actions;

export default firmSlice.reducer;
